/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CreateSiteSectionDocumentRequestSiteSectionDocumentFromJSON(json) {
    return CreateSiteSectionDocumentRequestSiteSectionDocumentFromJSONTyped(json, false);
}
export function CreateSiteSectionDocumentRequestSiteSectionDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentId: !exists(json, 'document_id') ? undefined : json['document_id'],
        siteSectionId: !exists(json, 'site_section_id') ? undefined : json['site_section_id'],
        sort: !exists(json, 'sort') ? undefined : json['sort']
    };
}
export function CreateSiteSectionDocumentRequestSiteSectionDocumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_id: value.documentId,
        site_section_id: value.siteSectionId,
        sort: value.sort
    };
}
